module.exports = __webpack_public_path__ + "static/love-footer-d7294581b75b51e32c5de5de1ad56492.jpg";